import React, { useCallback, useMemo, useState } from 'react';
import { LoadingContext } from './loading-context-types';

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const setLoading = useCallback((state: boolean) => setIsLoading(state), []);

  const value = useMemo(() => ({ isLoading, setLoading }), [isLoading, setLoading]);

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};
